import * as React from "react";

export function TodayWorkflowNodeIcon() {
    return (
        <svg
            viewBox="-22 -22 44 44"
            width="34"
            height="34"
            aria-hidden="true"
            focusable="false"
            style={{ overflow: "visible" }}
        >
            <defs>
                <linearGradient
                    id="todayWorkflowPanelGold"
                    x1="0"
                    y1="-16"
                    x2="0"
                    y2="16"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0%" stopColor="#f8de9a" />
                    <stop offset="20%" stopColor="#d2ac4a" />
                    <stop offset="55%" stopColor="#8a5d14" />
                    <stop offset="100%" stopColor="#4c3210" />
                </linearGradient>
                <linearGradient
                    id="todayWorkflowPanelGlow"
                    x1="0"
                    y1="-14"
                    x2="0"
                    y2="12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0%" stopColor="#fff0ba" stopOpacity="0.9" />
                    <stop offset="42%" stopColor="#ffe088" stopOpacity="0.25" />
                    <stop offset="100%" stopColor="#ffe088" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="todayWorkflowBarGold"
                    x1="0"
                    y1="-8"
                    x2="0"
                    y2="8"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0%" stopColor="#ffe7ae" />
                    <stop offset="42%" stopColor="#e0b658" />
                    <stop offset="100%" stopColor="#9f6a19" />
                </linearGradient>
                <linearGradient
                    id="todayWorkflowBarShade"
                    x1="0"
                    y1="-8"
                    x2="0"
                    y2="8"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0%" stopColor="#fff5cf" stopOpacity="0.28" />
                    <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
                </linearGradient>
            </defs>
            <g filter="drop-shadow(0 2px 2px rgba(0,0,0,0.72)) drop-shadow(0 0 7px rgba(255, 206, 92, 0.14))">
                <path
                    d="M -13.8 -13.6 L -10.9 -16.6 H 10.9 L 13.8 -13.6 V 14.6 L 10.8 17.6 H -10.8 L -13.8 14.6 Z"
                    fill="#120f0b"
                    stroke="url(#todayWorkflowPanelGold)"
                    strokeWidth="1.45"
                    strokeLinejoin="round"
                />
                <path
                    d="M -11.8 -11.9 L -9.6 -14.2 H 9.6 L 11.8 -11.9 V 12.8 L 9.6 15 H -9.6 L -11.8 12.8 Z"
                    fill="none"
                    stroke="rgba(255, 236, 171, 0.32)"
                    strokeWidth="0.8"
                    strokeLinejoin="round"
                />
                <path
                    d="M -8.7 -17.1 H -12.6 L -15.4 -14.3"
                    fill="none"
                    stroke="url(#todayWorkflowPanelGold)"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                />
                <path
                    d="M 8.7 -17.1 H 12.6 L 15.4 -14.3"
                    fill="none"
                    stroke="url(#todayWorkflowPanelGold)"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                />
                <path
                    d="M 0 -18.1 L 3 -14.8 L 0 -11.5 L -3 -14.8 Z"
                    fill="url(#todayWorkflowPanelGold)"
                    opacity="0.96"
                />
                <path
                    d="M -3.3 -14.4 C -6.2 -16.7 -8.4 -16.2 -9.5 -13.9 C -7.4 -14.4 -5.6 -13.5 -3.8 -11.7 Z"
                    fill="url(#todayWorkflowPanelGold)"
                    opacity="0.86"
                />
                <path
                    d="M 3.3 -14.4 C 6.2 -16.7 8.4 -16.2 9.5 -13.9 C 7.4 -14.4 5.6 -13.5 3.8 -11.7 Z"
                    fill="url(#todayWorkflowPanelGold)"
                    opacity="0.86"
                />
                <path
                    d="M 0 -12.2 L 1.8 -10.3 L 0 -8.7 L -1.8 -10.3 Z"
                    fill="url(#todayWorkflowPanelGold)"
                    opacity="0.72"
                />
                <path
                    d="M 0 -17.1 L 1.4 -14.8 L 0 -12.6 L -1.4 -14.8 Z"
                    fill="#1a1207"
                    opacity="0.38"
                />
                <path
                    d="M 0 18.4 L 1.7 16.7 L 3.9 17.8 L 3.4 15.4 L 5.8 14.7 L 3.4 14 L 3.9 11.6 L 1.7 12.7 L 0 11 L -1.7 12.7 L -3.9 11.6 L -3.4 14 L -5.8 14.7 L -3.4 15.4 L -3.9 17.8 L -1.7 16.7 Z"
                    fill="url(#todayWorkflowPanelGold)"
                    opacity="0.9"
                />
                <path
                    d="M -7.2 -4.8 H 7.2"
                    stroke="url(#todayWorkflowBarGold)"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                />
                <path
                    d="M -7.2 0.1 H 7.2"
                    stroke="url(#todayWorkflowBarGold)"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                />
                <path
                    d="M -7.2 5 H 7.2"
                    stroke="url(#todayWorkflowBarGold)"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                />
                <path
                    d="M -7.2 -4.8 H 7.2 M -7.2 0.1 H 7.2 M -7.2 5 H 7.2"
                    stroke="rgba(48, 28, 6, 0.82)"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                    transform="translate(0 0.7)"
                    opacity="0.35"
                />
                <path
                    d="M -6.5 -5.6 H 6.5 M -6.5 -0.7 H 6.5 M -6.5 4.2 H 6.5"
                    stroke="url(#todayWorkflowBarShade)"
                    strokeWidth="0.9"
                    strokeLinecap="round"
                    opacity="0.82"
                />
            </g>
        </svg>
    );
}
